// 頂部提示：「N 款遊戲的發售日改了」［全部更新］（GDO-25，§11.3）
import type { IndexRow } from '@dayone/core/snapshot';
import { useCalendar, useDrifts } from '../../calendar/useCalendar.ts';
import { t } from '../../i18n/zh-TW.ts';
import { CalendarClock, ICON } from '../../ui/icons/index.ts';

export function DriftBanner({ rows }: { rows: readonly IndexRow[] }) {
  const cal = useCalendar();
  const drifts = useDrifts(cal, rows);
  if (!cal || (!drifts.length && !cal.progress)) return null;
  return (
    <div className="banner banner-warn gcal-banner" role="status">
      <CalendarClock {...ICON} />
      <span>
        {cal.progress ? t.gcal.updating(cal.progress.done, cal.progress.total) : t.gcal.driftBanner(drifts.length)}
      </span>
      {!cal.progress && (
        <button type="button" className="btn" onClick={() => void cal.updateAll(drifts)}>
          {t.gcal.updateAll}
        </button>
      )}
      <button type="button" className="link-button" onClick={cal.openPanel}>
        {t.gcal.title}
      </button>
    </div>
  );
}
